import { formatCurrency } from 'common/FormatUtilities';
import { DiscountText, Line, Tag, Text, TextContainer } from './styles';

interface IPromoDiscountLine {
  discountPercent?: number;
  discountApplied: number;
}

export const DiscountLine = ({ discountPercent, discountApplied }: IPromoDiscountLine) => (
  <Line>
    <TextContainer>
      <Text>Discount</Text>
      {discountPercent && <Tag>{discountPercent}% Off</Tag>}
    </TextContainer>
    <DiscountText data-cy='order-discount-value'>{`-${formatCurrency(discountApplied)}`}</DiscountText>
  </Line>
);
